import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import clsx from 'clsx';
import Countdown from 'react-countdown';
import { isSameDay } from 'date-fns';
import useStyles from './styles';
import { useTheme } from 'theming';
import { DateDisplayer } from '../DateDisplayer';
import { Avatar } from '../Avatar';
import { Typography } from '../Typography';
import { Button } from '../Button';
import { Badge } from '../Badge';

var ScheduleCard = function ScheduleCard(_ref) {
  var _clsx2;

  var id = _ref.id,
      plan = _ref.plan,
      start_date = _ref.start_date,
      status_name = _ref.status_name,
      session_number = _ref.session_number,
      professional_name = _ref.professional_name,
      professional_picture_url = _ref.professional_picture_url,
      professional_specialty = _ref.professional_specialty,
      professional_document = _ref.professional_document,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      _ref$minutesOffspan = _ref.minutesOffspan,
      minutesOffspan = _ref$minutesOffspan === void 0 ? 3 : _ref$minutesOffspan,
      _ref$actionsComponent = _ref.actionsComponent,
      actionsComponent = _ref$actionsComponent === void 0 ? React.createElement(React.Fragment, null) : _ref$actionsComponent,
      _ref$showActions = _ref.showActions,
      showActions = _ref$showActions === void 0 ? false : _ref$showActions,
      _ref$showMedicalRetur = _ref.showMedicalReturnBadge,
      showMedicalReturnBadge = _ref$showMedicalRetur === void 0 ? false : _ref$showMedicalRetur,
      _ref$onScheduleStarte = _ref.onScheduleStarted,
      onScheduleStarted = _ref$onScheduleStarte === void 0 ? function () {} : _ref$onScheduleStarte,
      _ref$onClickJoin = _ref.onClickJoin,
      onClickJoin = _ref$onClickJoin === void 0 ? function () {} : _ref$onClickJoin;
  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      started = _useState2[0],
      setStarted = _useState2[1];

  var containerStyle = clsx(_defineProperty({}, classes.container, true));
  var innerContainerStyle = clsx((_clsx2 = {}, _defineProperty(_clsx2, classes.row, row), _defineProperty(_clsx2, classes.innerContainer, true), _clsx2));
  var showCountdown = isSameDay(new Date(), new Date(start_date));

  var renderCountdown = function renderCountdown(_ref2) {
    var hours = _ref2.hours,
        minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        completed = _ref2.completed;
    if (hours * 60 + minutes > minutesOffspan) return null;
    setStarted(true);
    onScheduleStarted();
    return React.createElement("div", {
      className: classes.countdown
    }, !completed && React.createElement(Typography, {
      variant: 'content3'
    }, "Come\xE7a em"), React.createElement(Typography, {
      variant: 'content3',
      nowrap: true
    }, !completed ? "".concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0')) : 'Já começou!'), React.createElement(Button, {
      variant: 'contained',
      color: 'primary',
      onClick: onClickJoin,
      customClassName: classes.button
    }, "Entrar"));
  };

  return React.createElement("div", {
    className: containerStyle
  }, React.createElement(DateDisplayer, {
    inlineStyles: {
      height: 'auto'
    },
    date: start_date,
    label: status_name,
    variant: started ? 'warning' : 'success'
  }), React.createElement("div", {
    className: innerContainerStyle
  }, React.createElement("div", {
    className: classes.avatar
  }, React.createElement(Avatar, {
    size: row ? 'medium' : 'small',
    alt: professional_name,
    src: professional_picture_url
  })), React.createElement("div", {
    className: classes.patientSection
  }, React.createElement(Typography, {
    variant: 'content2'
  }, session_number ? React.createElement(React.Fragment, null, session_number, "\xAA consulta com") : React.createElement(React.Fragment, null, "Consulta com")), React.createElement(Typography, {
    variant: 'content2',
    weight: 'bold'
  }, professional_name), React.createElement(Typography, {
    variant: 'content3'
  }, professional_specialty, " - ", professional_document)), showMedicalReturnBadge && React.createElement("div", {
    className: classes.badgeWrapper
  }, React.createElement(Badge, {
    colorScheme: 'grey'
  }, React.createElement(Typography, {
    variant: 'content3',
    weight: 'bold',
    inheritColor: true
  }, "CONSULTA DE RETORNO"))), React.createElement("div", {
    className: classes.planSection
  }, React.createElement(Typography, {
    variant: 'content3',
    customClassName: classes.scheduleId
  }, "ID ", id), React.createElement(Typography, {
    variant: 'content3',
    customClassName: classes.planName
  }, plan))), React.createElement("div", {
    className: classes.grow
  }), React.createElement("div", {
    className: classes.actions
  }, showActions && !started && actionsComponent, React.createElement(Countdown, {
    date: showCountdown ? new Date(start_date) : null,
    renderer: renderCountdown
  })));
};

export { ScheduleCard };